import { render, staticRenderFns } from "./UiSelect.vue?vue&type=template&id=2c3c6dfe&scoped=true&"
import script from "./UiSelect.vue?vue&type=script&lang=js&"
export * from "./UiSelect.vue?vue&type=script&lang=js&"
import style0 from "./UiSelect.vue?vue&type=style&index=0&id=2c3c6dfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3c6dfe",
  null
  
)

export default component.exports